import { CONSTANT } from '@const';
import {
	LinkExternalIdentityPayload,
	LinkExternalIdentityResponse,
	Linking,
	LinkWithReferencesPayload,
} from '@types';
import { compareDesc } from 'date-fns';

import { ApiError, ApiParams, ApiService } from '../api/ApiService';

const UNMATCHING_NAMES_ERROR_MESSAGE = 'WaterIQ has not been able to confirm your identity.';

export class ExternalIdentityService extends ApiService {
	static async linkExternalIdentity(linkingCode: string): Promise<LinkExternalIdentityResponse> {
		const payload: LinkExternalIdentityPayload = { code: linkingCode };
		const params: ApiParams = {
			method: 'POST',
			url: CONSTANT.LINKING_CODE_API_URL,
			data: payload,
		};
		return await this.executeApiRequest(params);
	}

	static async linkWithReferences(payload: LinkWithReferencesPayload): Promise<Linking> {
		const params: ApiParams = {
			method: 'POST',
			url: CONSTANT.LINKING_REFS_API_URL,
			data: payload,
		};
		return await this.executeApiRequest(params);
	}

	static async getLinkings(): Promise<Linking[]> {
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.LINKINGS_API_URL,
		};
		return await this.executeApiRequest(params).then((data: Linking[]) => {
			this.sortByDate(data);
			this.fixWordings(data);
			return data;
		});
	}

	static async isUnmatchingNamesError(error: ApiError) {
		return (
			ExternalIdentityService.getErrorStatusCode(error) === 403 &&
			ExternalIdentityService.getErrorMessage(error) === UNMATCHING_NAMES_ERROR_MESSAGE
		);
	}

	private static sortByDate(linkings: Linking[]) {
		linkings.sort((a, b) => {
			return compareDesc(new Date(a.dateSubmitted), new Date(b.dateSubmitted));
		});
	}

	private static fixWordings(linkings: Linking[]) {
		linkings.map(linking => {
			linking.title = linking.title.replace(new RegExp('issue-', 'gi'), 'Issue -');
			linking.status = linking.status.replace(new RegExp('inprogress', 'gi'), 'In progress');
			return linking;
		});
	}
}
